import axios from 'axios';

import {
  BlogApiSubscriberConfirm,
  BlogApiSubscriberReject,
  BlogApiSubscriberRequest,
} from './types';

const api = axios.create({
  baseURL: '/blog-admin/api',
});

export const BlogApi = {
  subscribe(data: BlogApiSubscriberRequest) {
    return api.post('/subscribers/receiver/', data);
  },
  confirmSubscribe(data: BlogApiSubscriberConfirm) {
    return api.put('/subscribers/confirm/' + data.token);
  },
  rejectSubscribe(data: BlogApiSubscriberReject) {
    return api.put('/subscribers/reject/' + data.token);
  },
};
